import { translation } from "@/i18n";
import { nsUpload } from "@/i18n/locales/upload";
import { useWarningButtonWithoutBorderStyles } from "@/styles";
import { Button } from "@fluentui/react-components";
import { DocumentCheckmarkRegular } from "@fluentui/react-icons";
import React from "react";
import { DragAndDropAcceptFileType } from "./index";
import styles from "./index.module.css";

const useTranslation = translation.use(nsUpload);

export function RenderUploadedRow({
  file,
  id,
  isDisableDeleteButton,
  onDelete,
  fileType,
}: {
  file: File;
  id: string;
  isDisableDeleteButton: boolean;
  onDelete: (id: string) => void;
  fileType?: DragAndDropAcceptFileType;
}) {
  const { t } = useTranslation();
  const buttonWithoutBorderClasses = useWarningButtonWithoutBorderStyles();

  const kBSize = file.size / 1000;
  const isCSV = fileType === "csv";

  const dimClass = isDisableDeleteButton ? styles.dim : "";

  return (
    <div className={styles.uploadedData}>
      <div className={styles.info}>
        <DocumentCheckmarkRegular
          style={{
            fontSize: 20,
          }}
        />
        {isCSV && <div className={styles.subtitle}>{t.upload.dataName()}</div>}
        <div className={`${styles.name} ${dimClass}`} title={file.name}>
          {file.name}
        </div>
        {!isCSV && (
          <span className={dimClass}>
            {String(Math.round(kBSize * 10) / 10)}KB
          </span>
        )}
        <Button
          disabled={isDisableDeleteButton}
          className={buttonWithoutBorderClasses.warning}
          onClick={() => {
            onDelete(id);
          }}
        >
          {t.upload.deleteButton()}
        </Button>
      </div>
    </div>
  );
}
